import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Family Counseling Associates of Massachusetts theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const FCAOFMA_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/fcaofma/logo.png",
        alt: "Family Counseling Associates of Massachusetts Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 22,
  state: "MA",
  departmentIds: [133, 135, 136, 146, 156, 162, 234],
};
